module.exports = __webpack_public_path__ + "static/scale-model-of-cincinnati-observatory-in-cincinnati-ohio-56c52b6ee51700d1c32b8d0b424c3fc4.png";